<template>
  <nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
    <router-link
      class="navbar-brand col-sm-3 col-md-2 mr-0"
      :to="getUser && getUser.type === 'customer' ? '/helpdesk' : '/dashboard'"
      >KV sistem - Interni nalozi</router-link
    >
    <ul class="navbar-nav px-3" style="">
      <li class="nav-item text-nowrap">
        <a
          class="nav-link"
          href="#"
          style="display:inline;"
          v-if="getUser && getUser.type === 'customer' && getCompanyData"
          ><span>{{ getCompanyData.companyName }} -</span> {{ getUser.name }}</a
        >
      </li>
      <li class="nav-item text-nowrap">
        <a class="nav-link" href="#" @click="logOut()">Sign out</a>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    logOut() {
      this.$store.dispatch("signOut");
    }
  },
  computed: {
    getUser() {
      return this.$store.getters.user;
    },
    getCompanyData() {
      return this.$store.getters.getCompanyData;
    }
  }
};
</script>
